import { createFileRoute } from "@tanstack/react-router";
import ProfileForm from "@/components/profile/profile-form";
import NotificationPreferences from "@/components/profile/notification-preferences";

export const Route = createFileRoute("/_authenticated/profile")({
  component: ProfilePage,
});

function ProfilePage() {
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <ProfileForm />
        <NotificationPreferences />
      </div>
    </div>
  );
}
